import Grid from '@/models/Grid'
import User, { hasRole, Role } from '@/models/User'

export default class GridPolicy {
    viewAny(_user: User) {
        return false
    }

    view(user: User, grid: Grid) {
        switch (user.role) {
            case Role.USER:
                return user.company?.id === grid.entry.catalog.company.id
            case Role.AUDITOR:
                return grid.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
            default:
                return false
        }
    }

    create(user: User) {
        return hasRole(user, Role.USER)
    }

    update(user: User, grid: Grid) {
        return hasRole(user, Role.USER) && user.company?.id === grid.entry.catalog.company.id
    }

    restore(user: User, grid: Grid) {
        return hasRole(user, Role.USER) && user.company?.id === grid.entry.catalog.company.id
    }

    delete(user: User, grid: Grid) {
        return hasRole(user, Role.USER) && user.company?.id === grid.entry.catalog.company.id
    }

    forceDelete(_user: User, _grid: Grid) {
        return false
    }
}
